import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    description: {
        width: '100%',
        fontSize: '12px',
        marginBottom: 0,
        lineHeight: '18px',
        textAlign: 'center',
        fontFamily: 'Poppins-Regular',
        [theme.breakpoints.up('lg')]: { textAlign: 'left' }
    },
    responsive_margin: {
        margin: 'auto',
        [theme.breakpoints.up('lg')]: {
            margin: 0
        }
    },
    rotate180: {
        transform: 'rotate(180deg)'
    },
    chevron: {
        display: 'inline-block',
        float: 'right',
        [theme.breakpoints.up('md')]: { display: 'none' }
    },
    linkItem: {
        color: '#333',
        fontSize: '14px',
        lineHeight: '26px',
        fontFamily: 'Poppins-Regular',
        '&:hover': { color: '#4519EF', opacity: 0.8 }
    },
    h6: {
        fontSize: '16px',
        lineHeight: '26px',
        fontFamily: `Poppins-SemiBold !important`,
        marginTop: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.up('lg')]: { marginBottom: '20px', marginTop: 0 }
    }
}));
//# sourceMappingURL=footer.js.map